import request from '@/utils/request'

// 上传文件
export function uploadFile(data) {
  return request({
    url: '/group1/upload?output=json',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/fileUtil.js